export enum PathPriority {
  NONE,
  LEFT,
  RIGHT,
}
